import { Table } from "antd";
import React, { useState } from "react";
import Fees from "./atom/fees";

function Body({
  domainBrand,
  countries,
  currency,
  isLoading,
  defaultChargeList,
}) {
  const dictionary = domainBrand.domainBrand["languageDictionary"];
  const { Column } = Table;
  const [filterValue, setFilterValue] = useState("");

  const tableData =
    defaultChargeList &&
    defaultChargeList?.map((i, idx) => {
      return { ...i, key: idx + 1 };
    });

  return (
    <div className="app-content hor-content">
      <div className="container">
        <div className="page-header">
          <div>
            <h1 className="page-title">
              {dictionary ? dictionary["l_default_charges"] : "Fix Amount Fees"}
            </h1>
            <ol className="breadcrumb">
              <li className="breadcrumb-item active" aria-current="page">
                {dictionary
                  ? dictionary["WO_VIEW_AND_ALLOCATE_CO_-1430763282"]
                  : `View and allocate commission share to various combinations of paycenters.`}
              </li>
            </ol>
          </div>
        </div>
        <div className="row row-sm">
          <div className="col-lg-12 col-md-12">
            <div className="card overflow-hidden">
              <div className="card-body">
                <Fees
                  dictionary={dictionary}
                  countries={countries}
                  currency={currency}
                />
              </div>
            </div>
          </div>

          {/* BOTTOM */}
          <div className="col-lg-12 col-md-12">
            <div className="card overflow-hidden">
              <div className="card-body">
                <div className="col-lg-6 col-md-6 mb-3 mt-2 pt-3 pb-3">
                  <input
                    type={"text"}
                    className="form-control px-3"
                    value={filterValue}
                    onChange={(e) => setFilterValue(e.target.value)}
                    placeholder="Search..."
                  />
                </div>

                <div className="table-responsive">
                  <Table
                    dataSource={tableData}
                    className="w-100 table tbody"
                    loading={isLoading}
                  >
                    <Column
                      title="Applicable To"
                      dataIndex="createdDate"
                      key="1"
                      className=""
                    />
                    <Column
                      title="Delivery Method"
                      dataIndex="createdDate"
                      key="2"
                      className=""
                    />
                    <Column
                      title="Transaction Originating Country"
                      dataIndex="createdDate"
                      key="3"
                      className=""
                    />
                    <Column
                      title="Currency Code"
                      dataIndex="createdDate"
                      key="4"
                      className=""
                    />
                    <Column
                      title="Amount"
                      dataIndex="createdDate"
                      key="5"
                      className=""
                    />
                    <Column
                      title="Commission Type"
                      dataIndex="createdDate"
                      key="6"
                      className=""
                    />
                    <Column
                      title="Action"
                      dataIndex="createdDate"
                      key="7"
                      className=""
                    />
                  </Table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Body;
